/** * @author Akhila * @email 83606@global.ul.com * @create date 2020-01-19 12:21:40 * @modify date
2020-01-19 12:21:40 * @desc No service added popup */
<template>
  <div>
    <div class="mb-15 mt-15">No service added</div>
    <div class="center">
      <img src="/static/images/icons/marketplace.svg" class="market_place_img" alt="market-imgs" />
    </div>
    <div class="center">
      Checkout the
      <a class="cursor-pointer" @click="redirect('/layout/market-place')" data-dismiss="modal"
        >Marketplace</a
      >
      to browse our services.
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    redirect(url) {
      if (url !== this.$route.path) this.$router.push(url);
      this.$emit('closepopup');
    },
  },
};
</script>
<style lang="scss" scoped>
.market_place_img {
  width: 18%;
  margin-top: 7%;
}
</style>
